import { SvgIconProps } from '@freighthub/silhouette-core'
import { config } from 'app/config'
import { CustomerFeature } from 'domain/Customer'
import { ComponentType } from 'react'
import { matchPath } from 'react-router-dom'
import { UserRole } from 'service/roles'

export interface NavItem {
  tooltip: string
  icon: ComponentType<SvgIconProps>
  selectedIcon?: ComponentType<SvgIconProps>
  href: string
  target?: string
  exact?: boolean
  validPaths?: string[]
  authorize?: UserRole[]
  feature?: CustomerFeature
  showBadge?: boolean
  onClick?: () => void
  userlaneId?: string
}

export const isRouteItemActive = (item: NavItem): boolean => {
  if (!item.validPaths) {
    return !!matchPath(window.location.pathname, {
      path: item.href,
      exact: item.exact,
    })
  }
  return item.validPaths.some(
    (path) =>
      !!matchPath(window.location.pathname, {
        path: `${config.APP_BASE_URL}${path}`,
        exact: item.exact,
      })
  )
}
